// Keep the redesign ATC button + product prices in sync with the selected plan.
// Prices come from the Liquid-emitted [data-atc-prices] map (variant id -> { onetime, <sellingPlanId>: price }),
// so there is no DOM scraping. Initial state is server-rendered; this only reacts to plan/variant changes.
(function () {
  var prices = {};
  var data = document.querySelector('script[data-atc-prices]');
  if (data) { try { prices = JSON.parse(data.textContent); } catch (e) { return; } }

  function selectedPrice(form) {
    var idInput = form.querySelector('[name="id"]');
    var entry = idInput && prices[idInput.value];
    if (!entry) return '';

    var option = document.querySelector('input[name="purchaseOption"]:checked');
    if (option && option.value === 'subscription') {
      var plan = document.querySelector('[name="rc_selling_plan"]');
      return (plan && entry[plan.value]) || entry.onetime;
    }
    return entry.onetime;
  }

  function renderButton(btn, price) {
    var label = (btn.querySelector('.atc-button__label') || btn).textContent.trim();
    btn.innerHTML =
      '<span class="atc-button__label">' + label + '</span>' +
      (btn.disabled || !price
        ? ''
        : '<span class="atc-button__dot" aria-hidden="true">•</span><span class="atc-button__price">' + price + '</span>');
  }

  function sync() {
    var btn = document.querySelector('.atc-button--redesign');
    var form = btn && btn.closest('form');
    if (!form) return;

    var price = selectedPrice(form);
    if (!price) return;

    document.querySelectorAll('sale-price[form]').forEach(function (sale) {
      if (sale.lastChild) sale.lastChild.textContent = price;
    });
    document.querySelectorAll('.atc-button--redesign').forEach(function (b) {
      renderButton(b, price);
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.name === 'purchaseOption' || event.target.name === 'rc_selling_plan') sync();
  });

  // On variant change the theme wipes the button and resets <sale-price> to the one-time price; re-sync.
  document.addEventListener('variant:change', sync);
})();
